import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getT } from "@/i18n";

const LanguageContext = createContext({
  lang: "en",
  t: getT("en"),
  setLang: () => {},
  toggleLang: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    return window.localStorage.getItem("bl_lang") || "en";
  });

  const applyDir = useCallback((l) => {
    const t = getT(l);
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("dir", t.dir);
      document.documentElement.setAttribute("lang", l);
    }
  }, []);

  useEffect(() => {
    applyDir(lang);
    try {
      window.localStorage.setItem("bl_lang", lang);
    } catch (e) {}
  }, [lang, applyDir]);

  const setLang = (l) => setLangState(l === "ar" ? "ar" : "en");
  const toggleLang = () => setLangState((l) => (l === "en" ? "ar" : "en"));

  const value = { lang, t: getT(lang), setLang, toggleLang };
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
